<template>
  <!-- the list of shipping orders -->
  <div>
    <!-- the title (should be dynamic some day when we make lists of lists) -->
    <div class="majorTitle">
      Shipping Orders
    </div>

    <!-- Loop through the lists of grouped shipping orders -->
    <div
      v-for="group in groupedShippingOrders"
      :key="group.title"
    >
      <!-- The title for this group of shipping orders -->
      <div class="minorTitle">
        {{ group.title }}
      </div>

      <!-- The list of items -->
      <ul v-if="group.shippingOrders.length > 0 || requestQuoteInventoryIds.length > 0">
        <!-- Show any items that need fullfillment arrangements --> 
        <li
          v-if="requestQuoteInventoryIds.length > 0 && group.title === 'Require Action'"
          class="itemRow"
        >
          <a
            class="colorBlack navLink u-full-width"
            @click="showArrangeShipping"
          >
            <div class="dropdownLeadImageContainer">
              <img
                v-if="(requestQuoteLeadImage.length > 0)"
                :src="requestQuoteLeadImage"
                alt=""
              >
            </div>
            <div>
              <span>
                {{ requestQuoteInventoryIds.length }} item<span v-if="requestQuoteInventoryIds.length > 1">s</span> require<span v-if="requestQuoteInventoryIds.length === 1">s</span> shipping or pick-up arrangements.
              </span>
            </div>
          </a>
        </li>

        <!-- Loop through the shipping orders -->
        <li
          v-for="shippingOrder in group.shippingOrders"
          :id="'item-card-' + shippingOrder.shipping_order_id"
          :key="shippingOrder.shipping_order_id"
          class="itemRow"
        >
          <ShippingOrderCard :shipping_order_id="shippingOrder.shipping_order_id" />
        </li>
      </ul>

      <!-- There are no shipping orders in this list -->
      <div
        v-else
        class="colorGrey textCenter"
      >
        No shipping orders.
      </div>
    </div>

    <!-- The interset observer that fires when it enters the viewport -->
    <Observer @intersect="onIntersect" />
  </div>
</template>

<script>
import ShippingOrderCard from '@/components/ShippingOrderCard'
import Observer from '@/components/Observer'

export default {

	name: 'ShippingOrderList',

	components: {
		ShippingOrderCard,
		Observer
	},

	props: [
		'listTitle',
		'groupBy'
	],

	data () {
		return {
			'page': 0,
			'offset': 50
		}
	},

	computed: {

		// this was formerly in mapState - can't use that due to Edge
		shippingOrders: function() {
			return this.$store.state.shippingOrders
		},

		requestQuoteInventoryIds: function () {
			return this.$store.getters.requestQuoteInventoryIds
		},

		requestQuoteLeadImage: function () {
			if (
				this.$store.getters.item(this.$store.getters.requestQuoteInventoryIds[0]) !== null
			) {
				return this.$store.getters.item(this.$store.getters.requestQuoteInventoryIds[0]).thumbnail_image
			}

			return ''
		},

		// the shipping orders we are viewing right now
		groupedShippingOrders: function () {

			const self = this

			let tempShippingOrders = {}

			// we are grouping by selling and sold
			if (this.groupBy === 'require_action') {
				tempShippingOrders.requireAction = { 
					'title': 'Require Action',
					'shippingOrders': []
				}
				tempShippingOrders.complete = { 
					'title': 'Complete',
					'shippingOrders': []
				}
			}
	//console.log(self.shippingOrders)
			// loop through all of their shipping orders 
			Object.keys(self.shippingOrders).forEach(function (key) {

				let tempShippingOrder = {
					'shipping_order_id': self.shippingOrders[key].shipping_order_id,
					'target_url': self.shippingOrders[key].card.target_url,
					'image': self.shippingOrders[key].card.image,
					'title': self.shippingOrders[key].card.title
				}

				// we are grouping by paid and unpaid 
				if (self.groupBy === 'require_action') {
					
					// this shipping order requires action
					if (self.shippingOrders[key].requires_action === true) {
						//console.log(tempShippingOrder)
						tempShippingOrders.requireAction.shippingOrders.push(tempShippingOrder)

					// this shipping order does not require action
					} else {
						tempShippingOrders.complete.shippingOrders.push(tempShippingOrder)
					}
				}
					
			})

			tempShippingOrders.complete.shippingOrders = tempShippingOrders.complete.shippingOrders.slice(0, ((this.page * this.offset) + this.offset))
			return tempShippingOrders

		}
	},
	methods: {

		showInvoice (payload) {
			this.$store.dispatch('updateCurrentShippingOrder', payload)
			this.insertAccountMenu('Shipping Order')
		},

		showArrangeShipping (payload) {
			this.$store.dispatch('insertAccountHistory', 'Arrange Shipping or Pick up')
		},

		onIntersect () {
			this.page = this.page + 1
		}
	}
}

</script>

<style scoped>

</style>
